import React from 'react';

import { Block } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import Kit from '../layout/Kit.jsx';
import Layout from '../common/Layout.jsx';
import Token from '../common/Token.jsx';

const headerConversionMap = { [Token.ArtistName]: 'h1', [Token.Title]: 'h1' };

// region HEADER TEXT

function HeaderTextComponent(props) {
    const globalPageKit = Kit.kit(props.config, Kit.Type.Global);
    let pageType = globalPageKit ? 'h2' : Kit.Type.HeaderText2;
    let useKit = true;
    let design, display, style;
    if (props.blockConfig) {
        style = {};
        if (props.blockConfig.block) {
            switch (props.blockConfig.block.level) {
                case '1':
                    pageType = globalPageKit ? 'h1' : Kit.Type.HeaderText1;
                    break;
                case '3':
                    pageType = globalPageKit ? 'h3' : Kit.Type.HeaderText3;
                    break;
            }
            if (props.blockConfig.block.useKit) {
                display = props.blockConfig.block.display;
            } else {
                design = props.blockConfig.block.design;
                useKit = false;
            }
            Block.mapStyleConfigProps(style, props.blockConfig.block, (propName) => {
                switch (propName) {
                    case 'design':
                    case 'display':
                    case 'level':
                    case 'useKit':
                        return true;
                }
            });
        }
        if (props.blockConfig.layout) {
            Block.mapStyleConfigProps(style, props.blockConfig.layout, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'alignment':
                    case 'maxHeight':
                    case 'maxWidth':
                    case 'minHeight':
                    case 'minWidth':
                        return true;
                }
            })
            if (useKit) {
                Kit.Page.updateComponentStyle(style, props.config, pageType, ['marginBottom', 'marginLeft', 'marginRight', 'marginTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'])
            }
        }
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props);
    let className = 'richText';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    let content = design;
    if (!content && !props.defaultContent && !display) {
        if (!props.builder) {
            return null;
        }
        content = <div className={className} style={layoutStyles.style}><EmptyPlaceholder /></div>
    } else {
        if (!content) {
            // Use Kit design
            content = Kit.Page.currentValue({ config: props.config, name: 'design', pageType });
            if (content) {
                // Inject display text
                content = Token.parseTokenizedString(content, () => props.defaultContent && props.defaultContent(props) || display);
            }
            content = Token.convertTokenContainers(content, headerConversionMap);
        } else if (props.onProcessContent) {
            content = `<div class="cont--token">${props.onProcessContent(content)}</div>`;
        }
        if (props.config) {
            if (props.config.colors && props.config.colors.bodyHeaderText) {
                layoutStyles.style.color = props.config.colors.bodyHeaderText;
            }
            const fonts = Layout.Font.typedStrings(props.config);
            if (fonts.header) {
                layoutStyles.style.fontFamily = fonts.header;
            }
        }
        content = <div className={className} dangerouslySetInnerHTML={{ __html: content }} style={layoutStyles.style} />
    }
    if (layoutStyles.containerStyle) {
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}

// region TOKENIZED HEADER TEXT

function _HeaderTextTokenizedComponent(props) {
    return <HeaderTextComponent {...props} defaultContent={(props) => props.onParseContent(props, props.defaultDesign) } onProcessContent={(content) => props.onParseContent(props, content)} />
}
const HeaderTextTokenizedComponent = Token.withContentTokenParsing(
    _HeaderTextTokenizedComponent,
    {
        contentTokenSourceHandler: (props) => props.blockConfig.block.useKit ? props.defaultDesign : props.blockConfig.block.design,
        extraParseConditionHandler: (props) => {
            const parseConditions = props.onParseConditions ? [...props.onParseConditions(props)] : [];
            parseConditions.push(props.blockConfig.block.useKit);
            return parseConditions
        },
        headerConversionMap
    },
    (props, keyword, options) => Token.parsing[props.type] ? Token.parsing[props.type]({ [props.type]: props.data || {}, wrapContent: false }, keyword, options) : ''
);

export default { Component: HeaderTextComponent, TokenizedComponent: HeaderTextTokenizedComponent };